export default __webpack_public_path__ + "static/media/algodao_f1_a_f7.a928e4a3.png";